export default __webpack_public_path__ + "static/media/viewing-demo-profile.0b698d73.png";